define(['jquery', 'validate'], function($, validate) {
    var AJAX_URL = '/wp-admin/admin-ajax.php';

    $('#checkout [data-action="pay-full"]').on('click', function() {
        $(this).closest('form').submit();
    });
    $('#checkout [data-action="pay-reserve"]').on('click', function() {
        $('[name=paid_full]').val($(this).data('value'));
        $(this).closest('form').submit();
    });
    $('form#checkout').submit(function() {
        $('#checkout div.message').html('');
        $('#checkout div.error-message').html('');
        var formContraints = {
            first_name: {
                presence: true
            },
            last_name: {
                presence: true
            },
            email_address: {
                presence: true
            },
            contact_number: {
                presence: true,
                format: {
                    pattern: "^(?=(?:\\D*\\d\\D*){8,14}$)[ -]*\\+?[ -]*(?:\\((?:[ -]*\\d)+[ -]*\\))?[- \\d]*"
                }
            },
            address_line_1: {
                presence: true
            },
            town: {
                presence: true
            },
            postcode: {
                presence: true,
            },
            country_code: {
                presence: true
            },
            agree_terms: {
                presence: {
                    message: "^You must agree to the terms and conditions"
                }
            }
        };
        var form = $(this).serializeArray().reduce(function(obj, item) {
            if (item.value) {
                obj[item.name] = item.value;
            }
            return obj;
        }, {});
        if(form.country_code === 'GB') {
            formContraints.postcode.format = {
                pattern: '^([Gg][Ii][Rr] {0,1}0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}[0-9][A-Za-z]{2})$',
                message: "not valid."
            };
        }
        var validatedData = validate(form, formContraints);

        if (validatedData === undefined) {
            //saveCustomer(form);
            return true;
        } else {
            $.each(validatedData, function(i, item) {
                $('.field #' + i).closest('.field').next().html('<span>' + item[0] + '</span>');
            });
            $('#checkout div.error-message').html('There are some errors on this page. Please fix them before continuing.');
        }
        return false;
    });

    var addCountryCodes = function() {
        $.post(AJAX_URL, {
                action: 'add_country_codes'
            })
            .done(function(response) {
                $('#country_code').append(response);
            });
    };

    var bindSpecialRequestButton = function() {
        $('[data-action="special-request"]').on('click', function() {
            var $textbox = $(this).parent().parent().find('.special-request-textbox');

            if ($textbox.hasClass('open')) {
                $textbox.removeClass('open');
            } else {
                $textbox.addClass('open');
            }
        });
    };

    bindSpecialRequestButton();

    if ($('#country_code').length) {
        addCountryCodes();
    }
});